import { apiClient } from './client';
import type {
  ServiceCatalogCreateInput,
  ServiceCatalogItemDto,
  ServiceCatalogPatchInput,
} from '@expeditor/shared';

/** Справочник доп. услуг: админ управляет, клиент выбирает активные. */
export const serviceCatalogApi = {
  /** Клиент: активные услуги (для выбора в поручении). */
  async listActive(): Promise<ServiceCatalogItemDto[]> {
    const { data } = await apiClient.get<ServiceCatalogItemDto[]>('/service-catalog/active');
    return data;
  },
  /** Админ: все услуги. */
  async listAll(): Promise<ServiceCatalogItemDto[]> {
    const { data } = await apiClient.get<ServiceCatalogItemDto[]>('/admin/service-catalog');
    return data;
  },
  /** Админ: добавить услугу. */
  async create(dto: ServiceCatalogCreateInput): Promise<ServiceCatalogItemDto> {
    const { data } = await apiClient.post<ServiceCatalogItemDto>('/admin/service-catalog', dto);
    return data;
  },
  /** Админ: изменить (название / активность / порядок). */
  async update(id: string, patch: ServiceCatalogPatchInput): Promise<ServiceCatalogItemDto> {
    const { data } = await apiClient.patch<ServiceCatalogItemDto>(
      `/admin/service-catalog/${id}`,
      patch,
    );
    return data;
  },
};
